<div class="container">
  <gds-spacer classes="spacer-70"></gds-spacer>
  <!-- gds picture -->
  <gds-image
    desktop="{{ baseUrl }}"
    mobile="{{ baseUrl }}"
    tablet="{{ baseUrl }}"
    alt="{{ pageLabels?.['deleteAccComp.image_AltText'] }}"
    tabindex="0"
    aria-label="{{ pageLabels?.['deleteAccComp.image_AltText'] }}"
  >
  </gds-image>
  <gds-spacer classes="spacer-70"></gds-spacer>

  <!-- delete info messages -->
  @if (!showContent) {
    <div
      tabindex="0"
      aria-label="{{
        pageLabels?.['deleteAccComp.msg1'] + pageLabels?.['deleteAccComp.msg2']
      }}"
    >
      <gds-heading
        [data]="{
          heading: pageLabels?.['deleteAccComp.msg1'],
        }"
        class="A3-W6"
      ></gds-heading>
      <gds-spacer classes="spacer-50"></gds-spacer>
      <!-- delete info meassages  -->
      <gds-heading
        [data]="{
          heading: pageLabels?.['deleteAccComp.msg2'],
        }"
        class="B1-W3"
      >
      </gds-heading>
    </div>
  }
  @if (showContent) {
    <div
      tabindex="0"
      aria-label="{{
        pageLabels?.['deleteAcc.heading1'] +
          pageLabels?.['deleteAccComp.msg1'] +
          pageLabels?.['deleteAccComp.msg2']
      }}"
    >
      <gds-heading
        [data]="{
          heading: pageLabels?.['deleteAcc.heading1'],
        }"
        class="A3-W6"
      ></gds-heading>
      <gds-spacer classes="spacer-50"></gds-spacer>
      <!-- delete info meassages  -->
      <gds-heading
        [data]="{
          heading:
            pageLabels?.['deleteAccComp.msg1'] +
            '<br>' +
            pageLabels?.['deleteAccComp.msg2'],
        }"
        class="B1-W3"
      >
      </gds-heading>
    </div>
  }
  <gds-spacer classes="spacer-50"></gds-spacer>

  <!-- Return to Home page Button -->
  <div>
    <gds-buttons
      [data]="{
        type: 'primary',
        href: '',
        label: pageLabels?.['deleteAccComp.return'],
        disabled: '',
        target: '',
      }"
      (buttonClicked)="goToHomepage()"
    >
    </gds-buttons>
  </div>
  <gds-spacer classes="spacer-50"></gds-spacer>
</div>
